import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ul {
    list-style-type: none;
  }

  td {
    padding: 4px 8px;
  }
`;
